import styled from "styled-components";

export const _HeaderPetitPrinceDecorationBaseContainer = styled("div")(() => {
  return {
    position: "relative",
    zIndex: 2,
    width: "100%",
    height: "100%",
  } as const;
});
